import {Component, Injector} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ModalResult} from "../model/common.model";
import {SafeHtml} from "@angular/platform-browser";

@Component({
  templateUrl: 'DlgAskYesNoQuestion.html',
})
export class DlgAskYesNoQuestion {


  title: string;
  message: string;
  messageHtml: SafeHtml;
  positiveButtonTitleCode: string;
  negativeButtonTitleCode: string;

  askExtraConfirmation = false;
  extraConfirmation = false;
  constructor(public activeModal: NgbActiveModal, private injector: Injector){


  }

  populate(title: string, msg: string,htmlMessage?:SafeHtml, askExtraConfirmation?: boolean){

    this.title = title;
    this.message = msg;
    this.positiveButtonTitleCode = 'Yes';
    this.negativeButtonTitleCode = 'No';
    if (htmlMessage){
      this.messageHtml = htmlMessage;
    }
    if (askExtraConfirmation){
      this.askExtraConfirmation = askExtraConfirmation;
    }else{
      this.askExtraConfirmation = false;
    }
  }

    populateWithCustomButtons(title: string, msg: string, positiveButtonCode: string, negativeButtonCode: string,htmlMessage?:SafeHtml, askExtraConfirmation?: boolean){

        this.title = title;
        this.message = msg;
        this.positiveButtonTitleCode = positiveButtonCode;
        this.negativeButtonTitleCode = negativeButtonCode;
        if (htmlMessage){
          this.messageHtml = htmlMessage;
        }
        if (askExtraConfirmation){
          this.askExtraConfirmation = askExtraConfirmation;
        }else{
          this.askExtraConfirmation = false;
        }
    }

  onValidate(){
    this.activeModal.close(ModalResult.YES);
  }

  onCancel(){
    this.activeModal.close(ModalResult.CANCEL);
  }


}
